import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useState } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { logout } from 'src/api/services/supabase/auth';
import { useUserStore } from 'src/store/user-store';

export const useSignOut = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const [isSigningOut, setIsSigningOut] = useState<boolean>(false);

  const {
    clearDirectoryToken,
    clearAdminToken,
    clearRole,
    clearViewContext,
    clearMeilisearchToken,
    clearMeilisearchTokenLockspace,
    clearDirectoryTokenLockspace,
  } = useUserStore();

  const signOut = useCallback(
    async (onSuccess?: () => void) => {
      setIsSigningOut(true);

      try {
        await logout();

        onSuccess?.();

        clearDirectoryToken();
        clearDirectoryTokenLockspace();
        clearAdminToken();
        clearRole();
        clearViewContext();
        clearMeilisearchToken();
        clearMeilisearchTokenLockspace();

        queryClient.invalidateQueries();
        queryClient.removeQueries();
      } catch (err) {
        console.error(err);
        toast.error(t('common:errorMessages.somethingWentWrong'));
      } finally {
        setIsSigningOut(false);
      }
    },
    [
      clearAdminToken,
      clearDirectoryToken,
      clearDirectoryTokenLockspace,
      clearMeilisearchToken,
      clearMeilisearchTokenLockspace,
      clearRole,
      clearViewContext,
      queryClient,
      t,
    ],
  );

  return { signOut, isSigningOut };
};
